import { render } from "./AgenticSidebar.vue?vue&type=template&id=68538eee&scoped=true"
import script from "./AgenticSidebar.vue?vue&type=script&lang=js"
export * from "./AgenticSidebar.vue?vue&type=script&lang=js"

import "./AgenticSidebar.vue?vue&type=style&index=0&id=68538eee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68538eee"]])

export default __exports__